/**
 * Uygulamanın kurumsal kimliği — tek kaynak.
 *
 * Ad ve kısaltma birden çok yerde geçiyor (tarayıcı sekmesi, kenar çubuğu,
 * giriş ekranı, e-posta başlıkları). İki yerde tanımlanırsa biri güncellenip
 * diğeri unutulur ve kullanıcı iki farklı isim görür.
 */

/** Tam kurumsal ad — tarayıcı sekmesi, giriş ekranı, e-posta imzası. */
export const APP_NAME = 'KSKLC AMAZON SELLER APP';

/** Dar alanlarda kullanılan kısaltma — kenar çubuğu başlığı gibi. */
export const APP_SHORT_NAME = 'KSKLC';

/** Ne yaptığını bir cümlede anlatan alt başlık. */
export const APP_TAGLINE = 'Amazon satıcı yönetim paneli';
